module.exports = __webpack_public_path__ + "static/media/support-img.4149dea8.png";